var _title, _desc, _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcCloseGray = function SvgIcCloseGray(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 3")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 -0.00035 13.74215 -0.00035 13.74215 13.74215 0 13.74215"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-5.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5674,13.5674 C13.3344,13.8004 12.9524,13.8004 12.7194,13.5674 L6.8714,7.7194 L1.0234,13.5674 C0.7904,13.8004 0.4084,13.8004 0.1744,13.5674 C-0.0586,13.3344 -0.0586,12.9524 0.1744,12.7184 L6.0234,6.8714 L0.1744,1.0234 C-0.0586,0.7904 -0.0586,0.4084 0.1744,0.1744 C0.4084,-0.0586 0.7904,-0.0586 1.0234,0.1744 L6.8714,6.0224 L12.7194,0.1744 C12.9524,-0.0586 13.3344,-0.0586 13.5674,0.1744 C13.8004,0.4084 13.8004,0.7904 13.5674,1.0234 L7.7194,6.8714 L13.5674,12.7194 C13.8004,12.9524 13.8004,13.3344 13.5674,13.5674",
    id: "Fill-1",
    fill: "#ABB7CE",
    mask: "url(#mask-2)"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCloseGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_close_gray.3aadc40b.svg";
export { ForwardRef as ReactComponent };